import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Config } from './config';
import {firstValueFrom} from "rxjs";

/*
 * Loads configuration properties at runtime for this application
 */
@Injectable()
export class ConfigService {
  dashboardUI: string = "http://localhost:9000/dashboardui";
  dashboardUrl: string = "http://localhost:8081/dashboard";
  environment: string = "local";

  constructor(private readonly http: HttpClient) {
    this.loadProps().then(returnedProps => {
      //Sets values asynchronously - not immediately available to app
      // component, but sufficient for basic props used by sub-components
      this.dashboardUI = returnedProps.dashboardUI;
      this.dashboardUrl = returnedProps.dashboardUrl;
      this.environment = returnedProps.environment;
    });
  }

  loadProps(): Promise<Config> {
    return firstValueFrom(this.http.get('assets/HMLUploader-props.json', {}))
      .then(response => response)
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }
}
